<template>
  <footer class="footer">
    <p>合作与服务：0431-81782288</p>
    <p>Copyright 2019-2023 XJL. All Rights Reserved</p>
    <p>地址：吉林省长春市南关区南环城路1088号B1号楼401室</p>
    <p>邮政编码：130000 吉林省饮食文化研究会 版权所有</p>
    <p>
      <a href="http://beian.miit.gov.cn/" target="_blank"
        >吉ICP备17005125号-1</a
      >
    </p>
  </footer>
</template>

<script>
export default {};
</script>

<style lang="scss" scope>
.footer {
  font-size: 14px;
  text-align: center;
  padding: 15px 0;
  background: #292c33;
  color: #fff;
  p {
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  a {
    outline: none;
    text-decoration: none;
    color: inherit;
    margin: 0 5px;
  }
}
</style>
